import { map, switchMap, concatMap } from "rxjs";
import { DomSanitizer } from "@angular/platform-browser";
import { HttpClient } from "@angular/common/http";

import { Component, Input, OnChanges } from "@angular/core";

import { Subscription, BehaviorSubject, Observable, of } from "rxjs";
import { FilesManagerService } from "../dashboard/files-manager/files-manager.service";
import { AsyncPipe } from "@angular/common";

@Component({
    selector: "secured-image",
    template: ` <img [src]="dataUrl$ | async" /> `,
    imports: [AsyncPipe]
})
export class SecuredImageComponent implements OnChanges {
  // This code block just creates an rxjs stream from the src
  // this makes sure that we can handle source changes
  // or even when the component gets destroyed
  // So basically turn src into src$
  @Input() private src: any;
  src$ = new BehaviorSubject(null);

  // @Input() private file_uuid: string;
  // private file_uuid$ = new BehaviorSubject(this.file_uuid);

  ngOnChanges(changes): void {
    // console.log(changes);
    this.src$ = new BehaviorSubject(this.src);
    this.src$.next(this.src);
  }

  // this stream will contain the actual url that our img tag will load
  // everytime the src changes, the previous call would be canceled and the
  // new resource would be loaded
  dataUrl$ = this.src$.pipe(switchMap((url) => this.loadImage(url)));

  // we need HttpClient to load the image
  constructor(
    private httpClient: HttpClient,
    private domSanitizer: DomSanitizer,
    private filesManagerService: FilesManagerService,
  ) {}

  private loadImage(url: string): Observable<any> {
    return this.filesManagerService.getFileDetailsByUuid(this.src).pipe(
      map((r) => r),
      concatMap((result) => {
        if (result == null) return;
        const url = result["file"].url;

        return this.filesManagerService.getFileDownload(url).pipe(
          map((sub) => {
            // console.log("sub", sub);
            const blob = new Blob([sub], {
              type: result["file"].mime_type,
            });
            const _url = this.domSanitizer.bypassSecurityTrustUrl(
              window.URL.createObjectURL(blob),
            );

            // console.log("loadImage blobUrl", _url);
            this.src = _url;
            return _url;
          }),
        );
      }),
    );
  }
}
